import React, { useState, useEffect, useContext } from 'react';
import { Link, useNavigate } from "react-router-dom";
import resourcesServices from '../../services/resourcesServices';
import { InputContext } from '../../contexts/InputContext';
import MessageModal from '../../container/MessageModal';
import { errorClassification } from '../../errorHandler';

const ListaMaterialEstudio = () => {
  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)

  const [materialEstudios, setMaterialEstudios] = useState([]);
  const [renderHTML, setRenderHTML] = useState(false);

  // modal messages
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');
  const handleShowModal = (message) => {setModalBody(message); setShowModal(true)};
  const handleCloseModal = () => { setShowModal(false); setModalBody('') };

  useEffect(() => {
    obtenerMaterialEstudios();
  }, []);

  useEffect(() => {
    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( (authInformation.autenticado === true) && (authInformation.rol === 'Admin' || authInformation.rol === 'Veedor')){
      setRenderHTML(true)
    } else {
      setRenderHTML(false)
    }
  }, [authInformation]);

  const obtenerMaterialEstudios = async () => {
    try {
      const data = await resourcesServices.obtenerResources('material_estudios', '', '', '', '');

      setMaterialEstudios(data.data);
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const eliminarMaterialEstudio = async (material_estudio) => {
    try {
      if(window.confirm(`Está seguro que quiere eliminar a ${material_estudio.nombre}?`)){
        await resourcesServices.eliminarResource('material_estudios', material_estudio.id);

        const copiaMaterialEstudios = [...materialEstudios];
        setMaterialEstudios(copiaMaterialEstudios.filter((me) => me.id !== material_estudio.id))
      }

    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const listarMaterialEstudios = materialEstudios && materialEstudios.map((material_estudio, index) => {
    return (
      <tr key={index}>
        <td>{material_estudio.nombre}</td>
        <td>{
        material_estudio.archivoUrl &&
          <Link className="btn btn-link" target="_blank" to={material_estudio.archivoUrl}>Descargar</Link>
        }</td>
        <td>
        {authInformation.rol === 'Admin' ? (
          <div className="btn-group" role="group">
            <Link className="btn btn-primary" to={`/material_estudio/${material_estudio.id}/edit`}>Editar</Link>{' '}
            <button className="btn btn-danger" onClick={()=>eliminarMaterialEstudio(material_estudio)} >Eliminar</button>
          </div>
        ) : ('')
        }
        </td>
    </tr>
    )
  })

  return (
    <>
      <h1>Lista de Material de Estudio</h1>
      {
        (renderHTML) && (
          <>
          <div className="table-responsive small">
            <table className="table table-striped table-sm">
              <thead>
                <tr>
                  <th scope="col">Nombre</th>
                  <th scope="col">Archivo</th>
                  <th scope="col">Acción</th>
                </tr>
              </thead>
              <tbody>
                {listarMaterialEstudios}
              </tbody>
            </table>
          </div>
          </>
        )
      }
      <MessageModal
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        modalBody={modalBody}
     />
      </>

  );
};

export default ListaMaterialEstudio;